import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    eventMasterId: null,
    isAuthenticated: false,
    screenRights: []
};

const reduxMasterSlice = createSlice({
    name: 'reduxMaster',
    initialState,
    reducers: {

        // ✅ SET MASTER ID
        setEventMasterId: (state, action) => {
            state.eventMasterId = action.payload;
        },

        // ✅ SET MASTER ID
        setIsAuthenticated: (state, action) => {
            state.isAuthenticated = action.payload;
        },

        // ✅ SET SCREEN RIGHTS (from getScreenMasterList)
        setScreenRights: (state, action) => {
            state.screenRights = action.payload;
        },

        // ✅ LOGOUT - clear auth + rights of the logged in user
        logout: (state) => {
            state.isAuthenticated = false;
            state.screenRights = [];
        },
    },
});

export const {
    setEventMasterId,
    setIsAuthenticated,
    setScreenRights,
    logout,
} = reduxMasterSlice.actions;

export default reduxMasterSlice.reducer;
